import React, { useEffect, useMemo, useRef } from "react";
import { useParams } from "react-router-dom";
import { blogPosts, featuredPost } from "../../../components/blogs/data/blogData";
import ArticleHeroBanner from "../../../components/landingPage/ArticleDetailPage/ArticleHeroBanner";
import ArticleBody from "../../../components/landingPage/ArticleDetailPage/ArticleBody";
import ArticleRelatedSection from "../../../components/landingPage/ArticleDetailPage/ArticleRelatedSection";
import ResourcesCtaSection from "../../../components/landingPage/ResourcesPage/ResourcesCtaSection";
import { useReveal, useCountUp } from "../../../components/landingPage/common/landingHooks";

const BlogDetailPage = () => {
    const { slug } = useParams();
    const data = useMemo(() => [...blogPosts, featuredPost].find((blog) => blog.slug === slug), [slug]);
    const rootRef = useRef(null);
    useReveal(rootRef);
    useCountUp(rootRef);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [slug]);

    if (!data) return null;

    return (
        <div className="lp-page" ref={rootRef}>
            <ArticleHeroBanner post={data} />
            <ArticleBody post={data} />
            <ArticleRelatedSection currentSlug={data.slug} />
            <ResourcesCtaSection />
        </div>
    );
};

export default BlogDetailPage;
